<template>
    <div class="col">
        <fieldset>
            <legend @click.prevent="toggle">{{ activeTitle }}</legend>
            <SmoothExpand>
                <div v-show="isExpanded">
                    <slot />
                </div>
            </SmoothExpand>
        </fieldset>
    </div>
</template>

<script>
    import Vue from 'vue';
    import SmoothExpand from '@/components/SmoothExpand.vue';

    export default Vue.extend({
        name: 'Fieldset',
        props: {
            expanded: {
                type: Boolean,
                required: false,
                default: false
            },
            title: {
                type: String,
                required: true,
            },
            titleCollapse: {
                type: String,
                required: false,
            },
        },
        data() {
            return {
                isExpanded: this.expanded,
            };
        },
        computed: {
            activeTitle() {
                return this.isExpanded ? this.titleCollapse || this.title : this.title;
            }
        },
        methods: {
            toggle() {
                this.isExpanded = !this.isExpanded;
            }
        },
        components: {SmoothExpand}
    });
</script>

<style scoped lang="scss">
    fieldset {
        border: 1px solid lightgray;
        border-radius: 5px;
        width: 100%;
        margin: 10px 0;
        padding: 10px;

        legend {
            cursor: pointer;
            font-size: 1rem;
            width: auto;
            padding: 3px 10px;
            background: snow;
            border-radius: 20px;
            border: 1px solid lightgray;
        }
    }
</style>